
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingTemplateParticipantDtoFormGroup() {
return new FormGroup({
    meetingTypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    userId: new FormControl<number | undefined>(undefined),
})
;
}
      